// extracted by mini-css-extract-plugin
export default {"avatar":"freemium-manage-person-panels_avatar__XIdpN","header":"freemium-manage-person-panels_header__mnmHM"};